// extracted by mini-css-extract-plugin
var _1 = "Sidebar-module__animateUploadProgressBarWidth--f0iy1";
var _2 = "Sidebar-module__animatedBackground--VgjY5";
var _3 = "Sidebar-module__clickOutside--ztL4q";
var _4 = "Sidebar-module__contentMapIcon--yQaKT";
var _5 = "Sidebar-module__isSidebarSectionsModalOpen--o_M2L";
var _6 = "Sidebar-module__mainNavs--I0xsT";
var _7 = "Sidebar-module__navs--JessK";
var _8 = "Sidebar-module__scrolled--ZZMu7";
var _9 = "Sidebar-module__show--dbxkv";
var _a = "Sidebar-module__sidebar--UHP6v";
var _b = "Sidebar-module__teamNavRow--SFjFq";
var _c = "Sidebar-module__teamNavRowInner--m97Kt";
var _d = "Sidebar-module__userAvatar--kPvYb";
var _e = "20px";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "clickOutside", _4 as "contentMapIcon", _5 as "isSidebarSectionsModalOpen", _6 as "mainNavs", _7 as "navs", _8 as "scrolled", _9 as "show", _a as "sidebar", _b as "teamNavRow", _c as "teamNavRowInner", _d as "userAvatar", _e as "userAvatarSize" }
